import { useState } from 'react'
import Header from '@components/Header/Header'
import AccountNumberInput from '@components/AccountNumberInput/AccountNumberInput'
import BottomSheetDropdown, { BottomSheetDropdownOption } from '@components/BottomSheetDropdown/BottomSheetDropdown'
import NumericKeyboard from '@components/NumericKeyboard/NumericKeyboard'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useKeypadCaret } from '@hooks/useKeypadCaret'
import {
  Container,
  ContentContainer,
  InputSection,
  DropdownWrapper,
  InputWrapper,
  KeyboardSection
} from './PDAM.styles'
import { INTER } from '@styles/fonts'
import { NEUTRAL_300 } from '@styles/colors'

const PDAM = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [selectedCompany, setSelectedCompany] = useState<BottomSheetDropdownOption | undefined>()
  const [accountNumber, setAccountNumber] = useState('')

  const pdamIcon = 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/pam.svg'

  const companies: BottomSheetDropdownOption[] = [
    { label: 'PDAM Kota Jakarta', iconUrl: pdamIcon },
    { label: 'PDAM Kota Bandung', iconUrl: pdamIcon },
    { label: 'PDAM Kota Surabaya', iconUrl: pdamIcon },
    { label: 'PDAM Kota Semarang', iconUrl: pdamIcon },
    { label: 'PDAM Kota Yogyakarta', iconUrl: pdamIcon },
    { label: 'PDAM Kota Medan', iconUrl: pdamIcon },
    { label: 'PDAM Kota Makassar', iconUrl: pdamIcon },
    { label: 'PDAM Kota Palembang', iconUrl: pdamIcon },
    { label: 'PDAM Kota Malang', iconUrl: pdamIcon },
    { label: 'PDAM Kota Padang', iconUrl: pdamIcon },
    { label: 'PDAM Kota Denpasar', iconUrl: pdamIcon },
    { label: 'PDAM Kota Manado', iconUrl: pdamIcon },
    { label: 'PDAM Kota Balikpapan', iconUrl: pdamIcon },
    { label: 'PDAM Kota Pontianak', iconUrl: pdamIcon },
    { label: 'PDAM Kota Banjarmasin', iconUrl: pdamIcon },
  ]

  const { inputRef, handleKeyboardChange } = useKeypadCaret(accountNumber, setAccountNumber, {
    maxLength: 24,
  })

  const handleAccountNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccountNumber(e.target.value)
  }

  const handleContinue = () => {
    navigate('/payment-confirm', {
      state: {
        accountNumber,
        company: selectedCompany?.label,
        serviceType: 'pdam'
      }
    })
  }

  return (
    <Container>
      <Header
        title={t('pdam.header')}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <ContentContainer>
        <InputSection>
          <span
            style={{
              fontFamily: INTER.semiBold,
              fontSize: 14,
              color: NEUTRAL_300,
              marginBottom: -4
            }}
          >
            {t('pdam.selectCompany')}
          </span>
          <DropdownWrapper>
            <BottomSheetDropdown
              placeholder={t('pdam.companyPlaceholder')}
              options={companies}
              value={selectedCompany}
              onChange={setSelectedCompany}
              showSearch={true}
            />
          </DropdownWrapper>
          <InputWrapper>
            <AccountNumberInput
              ref={inputRef}
              title={t('pdam.accountNumberLabel')}
              value={accountNumber}
              onChange={handleAccountNumberChange}
              placeholder={t('pdam.accountNumberPlaceholder')}
              inputMode="none"
            />
          </InputWrapper>
        </InputSection>

        <KeyboardSection>
          <NumericKeyboard onChange={handleKeyboardChange} />
          <PrimaryButton
            onClick={handleContinue}
            disabled={!accountNumber || !selectedCompany}
          >
            {t('common.continue')}
          </PrimaryButton>
        </KeyboardSection>
      </ContentContainer>
    </Container>
  )
}

export default PDAM
